import { Logo } from "@/components/svgs";
import Link from "next/link";
import React from "react";

import { env } from "@/types/env";
import HamburgerMenu from "./hamburger-menu";
import MiniCart from "./mini-cart";

export default function MobileNav() {
  return (
    <div className="flex  gap-4 xl:gap-20 justify-between w-full items-center">
      <Link href="/" className="flex gap-3 justify-center items-center">
        <Logo className="w-10 h-10" />
        <span className="font-poppins uppercase font-bold text-primary-foreground">
          {env.NEXT_PUBLIC_SITE_TITLE}
        </span>
      </Link>
      <div className="flex gap-4">
        <MiniCart />
        <HamburgerMenu />
      </div>
    </div>
  );
}
